import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { queryClient } from '@/lib/react-query/queryClient';
import { endpoints } from '@/modules/jobs/constants';
import { jobsQueryKeys } from '@/modules/jobs/queries/queryKeys';

interface UpdateJobInboundSettingsParams {
  jobId: string;
  isInboundEnabled: boolean;
  publicJobDescription: string | null;
}

export const useUpdateJobInboundSettingsMutation = () =>
  useMutation({
    mutationFn: async ({ jobId, ...body }: UpdateJobInboundSettingsParams) => {
      const { data } = await fetchClient.PUT(endpoints.jobInbound, {
        params: { path: { id: jobId } },
        body,
      });
      return data;
    },
    onSuccess: (data, { jobId }) => {
      queryClient.setQueryData(jobsQueryKeys.inbound(jobId), data);
    },
  });
